
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {IAppState} from "@/interfaces/app-state.interface";
  import SimpleAppTable from "@/shared/AppTable/components/SimpleAppTable.vue";
  import {ISimilarNumbers} from "@/modules/barriers/interfaces/similar-numbers.interface";
  import {similarNumbers} from "@/modules/barriers/helpers/similar-numbers";
  import SimilarActionsCell from "@/modules/barriers/components/SimilarNumbers/SimilarActionsCell.vue";
  import {bus} from "@/plugins/bus";

  @Component({
    components: {
      SimpleAppTable,
      SimilarActionsCell,
      AppDialog,
    },
  })
  export default class SimilarNumbersPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'barriers', dialogName: 'similarNumbers' };
    tableProps = [];
    tableList = [];
    SimilarActionsCell = SimilarActionsCell;

    get storeState(): IAppState { return this.$store.state; }
    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    created() {
      this.prepareTableData(this.payloadPopup.similarNumbers);
      this.tableProps = ISimilarNumbers.TableSimilarNumbersColumns;
    }

    async mounted() {
      bus.$on(ISimilarNumbers.Event.ReloadSimilarNumbersTable, this.reloadTableData);
    }

    prepareTableData(similarNumbers: ISimilarNumbers.IEntity[]) {
      this.tableList = similarNumbers.map((item: ISimilarNumbers.IEntity) => {
        return {
          ...item,
          carNumberHtml: item.carNumberGreenFlag
            ? `<span class="color--green">${item.carNumber}</span>`
            : item.carNumber,
          status: item.carId
            ? item.enabled ? 'Активен' : 'Архив'
            : '<span class="color--red">Создать</span>',
        };
      });
    }

    async reloadTableData() {
      const similarNumbersArray: ISimilarNumbers.IEntity[] = await similarNumbers.getTableData(this.payloadPopup.barrier);
      this.prepareTableData(similarNumbersArray);
    }

    async confirmSelected(tableItem: ISimilarNumbers.IEntity, rowIndex: number) {
      await similarNumbers.selectSimilarNumber(this.payloadPopup.barrier, tableItem);
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }

    destroyed() {
      bus.$off(ISimilarNumbers.Event.ReloadSimilarNumbersTable);
    }

  }
